export enum Separator {
  COMMA = ',',
}
